<template>
  <div>

    <div class="progress-bar" v-if="progressBar"><span :style="{'width': progressBar+'%'}"></span></div>

    <div class="progress-bar__text" v-if="progressBar"><span v-t="'Uploading...'"></span> {{progressBar}}%</div>

    <Droppable @upload="uploadFile" class="file-area file-area--img" v-if="model.image&&model.image.image&&!progressBar" :style="{'background-image': 'url('+model.image.image+')'}">
      <h3 class="on-hover">Drop to upload</h3>
      <span class="on-hover" v-t="'JPG or PNG less than 10Mb'"></span>

      <a class="button replace-link" @click="$parent.$parent.editImage(model.image, deleteCallback, updateCallback, removeImage)">Edit Image</a>

    </Droppable>
    
    <div style="display:none;">{{cachebuster}}</div>
    
    <Droppable @upload="uploadFile" v-if="(!model.image||!model.image.image)&&!progressBar" class="file-area" @click="openImagePicker()">
      <h3 v-t="'Add Image'"></h3>
      <span v-t="'Click or Drag and Drop a JPG or PNG less than 10Mb'"></span>
      <h3 class="on-hover" v-t="'Drop to Upload'"></h3>
      <span class="on-hover" v-t="'JPG or PNG less than 10Mb'"></span>
    </Droppable>

  </div>

</template>

<script>

  import Droppable from '@/components/Droppable.vue'
  import fileService from '@/services/fileService.js'

  export default {
    props: ['model', 'cachebuster'],
    components: {
      Droppable,
    },
    data () {
      return {
        progressBar: false,
        file: null,
        modalEditImage: null,
        modalEditOpen: false
      }
    },
    methods: {
      deleteImage (image_id){
        this.$emit('remove')
      },
      updateImage (image){
        this.model.image = image
      },
      removeImage () {
          this.$emit('remove')
      },
      openImagePicker () {
        this.$global.pickerModal = this
        this.$parent.$parent.imagePicker()
      },
      setImage (image) {
        this.$emit('close', image)
      },
      handleChange(e) {
        this.$emit('input', e.target.value);
      },
      deleteCallback () {
        this.$emit('remove')
      },
      updateCallback (image) {
        this.model.image = image
      },
      uploadFile (file){
        if (!file.name.match(/\.(jpg|Jpeg|jpeg|png|gif|JPG|JPEG|PNG)$/)) {
          window.alert('You must choose an image file.');
        } else if( (file.size / 1024 / 1024) > 10){
          window.alert('The maximum file size is 10Mb, try compressing your file.');
        } else {
          this.progressBar = 1;
          var self = this
          fileService.uploadImage(file, function(progress){
            self.progressBar = progress;
          }, function(data){
            self.progressBar = false;
            self.model.image = data;
          });
        }
      }
    }
  }
</script>
